export default "__VITE_ASSET__WR1Qb1Kd__"